/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';

import { ModalServiceContext } from './../../../../ricos-context';
import type { ModalService } from './../../../../ricos-modals';
import { PLUGIN_MENU_MODAL_ID } from './../../../../ricos-types';

import styles from './AddPluginMenuMobileButton-scss';

const AddPluginMenuMobileButton = ({ toolbarItem }: $TSFixMe) => {
  const Icon = toolbarItem.presentation?.icon;
  const modalService: ModalService = useContext(ModalServiceContext) || {};
  return (
    <div className={styles.toggleButtonWrapper}>
      <div
        onMouseDown={e => e.preventDefault()}
        className={styles.toggleButton}
        role="button"
        data-hook="add-plugin-button-mobile"
        onClick={() => {
          modalService?.openRegisteredModal(PLUGIN_MENU_MODAL_ID, {
            positioning: { placement: 'bottom' },
            layout: 'drawer',
          });
        }}
        tabIndex={0}
      >
        <Icon />
      </div>
    </div>
  );
};

export default AddPluginMenuMobileButton;
